// extracted by mini-css-extract-plugin
export default {"error_boundary_container":"error-boundary_error_boundary_container__wC9mC"};